import React from 'react';
import styles from '../RoomBlock.module.scss';

const BadgeBlock = ({ status }) => {
  return (
    <div className={styles.badge}>
      <p className={styles.roomStatus}>{status}</p>
      <div className={styles.circle} />
    </div>
  );
};

export default BadgeBlock;
